import { locate, get } from '@didi/webx-js'
let _locationInfo = null

function setLocationInfo (data) {
  _locationInfo = data
}

export default function (params, resolve, reject) {
  if (_locationInfo) {
    resolve(_locationInfo)
    return
  }
  locate()
    .then(res => {
      const { lat, lng, cityId } = res
      if (lat && lng) {
        if (!cityId) {
          getCityInfo(res, resolve, reject)
        } else {
          res.cityName = res.area
          setLocationInfo(res)
          resolve(res)
        }
      } else {
        resolve(res)
      }
    })
    .catch(err => {
      reject(err)
      console.log('locate err', err)
    })
}

export function getCityInfo (opts, resolve) {
  const api = 'https://common.diditaxi.com.cn/webcore/geo/reversegeotop'
  const lat = opts.latitude || opts.lat
  const lng = opts.longitude || opts.lng
  const data = {
    from_lat: lat || -1,
    from_lng: lng || -1
  }
  get(api, { params: data, needSign: true })
    .then(res => {
      if (res.errno === 0) {
        opts.cityId = res?.data?.cityid || ''
        opts.cityName = res?.data?.area || res?.data?.city || ''
      }
    })
    .catch(err => {
      console.log('getCityInfo', err)
    })
    .finally(() => {
      setLocationInfo(opts)
      resolve(opts)
    })
}
